import { type ReactElement } from "react";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "next-i18next";

import { Layout } from "@/components/ui/Layout";
import { OtpRequestForm } from "@/components/elements/OtpRequestForm";

const OtpRequestPage = () => {
  const router = useRouter();
  const { t } = useTranslation("auth");
  const { next: redirectUrl } = router.query;

  return (
    <>
      <Head>
        <title>{`${t("otp.signInWithOtp")} | OwnSpace`}</title>
      </Head>
      <OtpRequestForm
        redirectUrl={
          typeof redirectUrl === "string" ? decodeURIComponent(redirectUrl) : undefined
        }
      />
    </>
  );
};

OtpRequestPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "auth",
        "validation",
        "common",
      ])),
    },
  };
};

export default OtpRequestPage;
